<!--Copy right - © 2024 tecera gmbh-->
<script>

    import ToggleButton from "../../buttons/ToggleButton.svelte";
    import { fade } from 'svelte/transition';
    export let latitude;
    export let longitude;
    export let classes = "";
    export let set_coords;
    export let setManCoords;
    let is_generate_coords_button_disabled = false;
    function clear_latitude() {
        latitude = null;
    }

    function clear_longitude() {
        longitude = null;
    }

    function set_coords2() {
        set_coords();
        is_generate_coords_button_disabled = true;
        setTimeout(function () {
            is_generate_coords_button_disabled = false;
        }, 2000);
    }

    
</script>

<ToggleButton
    classes={classes}
    id="setManCoords"
    label="Koordinaten manuell setzen"
    bind:toggle={setManCoords}/>

{#if setManCoords}
<div class="col-6 pl-0 ml-0" transition:fade={{ duration: 300 }}>
    <div class="input-group mb-2">
        <input
            bind:value={latitude}
            id="latitude"
            class="form-control py-1 edit_field coords"
            type="text"
            placeholder="Latitude"
            disabled={!setManCoords}
            aria-label="Search"
            maxlength="50"
            autocomplete="off"
        />
        <button
            class="btn bg-transparent btn-clear coords"
            class:hidden={latitude == null ? true : false}
            on:click={clear_latitude}
            disabled={!setManCoords}
        >
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>

<div class="col-6 pr-0 mr-0" transition:fade={{ duration: 300 }}>
    <div class="input-group mb-2">
        <input
            bind:value={longitude}
            id="longitude"
            class="form-control py-1 edit_field coords"
            type="text"
            placeholder="Longitude"
            disabled={!setManCoords}
            aria-label="Search"
            maxlength="50"
            autocomplete="off"
        />
        <button
            class="btn bg-transparent btn-clear coords"
            class:hidden={longitude == null ? true : false}
            on:click={clear_longitude}
            disabled={!setManCoords}
        >
            <i class="fa fa-times"></i>
        </button>
    </div>
</div>

<!-- Koordinaten aus  -->
<div class="input-group mb-4 mt-2" transition:fade={{ duration: 300 }}>
    <button
        class="btn btn-secondary btn-normal"
        id="coords_from_address"
        on:click={() => set_coords2()}
        disabled={is_generate_coords_button_disabled}
    >
        Koordinaten aus Addresse generieren
    </button>
</div>
{/if}